const SearchInput = ({ id, placeholder, value, onChange, onClear, label, title, dataTestId }) => {
	const baseTestId = dataTestId || id;

	return (
		<div data-testid={`${baseTestId}-container`} className="flex w-full flex-col">
			<label
				htmlFor={id}
				className="mb-2 flex place-items-start justify-start font-normal text-gray-400 text-xs sm:text-xs"
			>
				{label}
			</label>
			<div data-testid={`${baseTestId}-trigger`} className="relative w-full">
				{/* Search Icon */}
				<div
					data-testid={`${baseTestId}-icon`}
					className="absolute inset-y-0 start-0 flex items-center ps-3.5"
				>
					<svg
						className="h-4 w-4 text-gray-400 sm:h-5 sm:w-5 dark:text-white"
						aria-hidden="true"
						xmlns="http://www.w3.org/2000/svg"
						width="24"
						height="24"
						fill="currentColor"
						viewBox="0 0 24 24"
					>
						<path d="M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Z" />
						<path
							fillRule="evenodd"
							d="M21.707 21.707a1 1 0 0 1-1.414 0l-3.5-3.5a1 1 0 0 1 1.414-1.414l3.5 3.5a1 1 0 0 1 0 1.414Z"
							clipRule="evenodd"
						/>
					</svg>
				</div>
				<input
					data-testid={`${baseTestId}-text`}
					type="text"
					id={id}
					value={value}
					onChange={(e) => onChange(id, e.target.value)}
					className="b block w-full truncate rounded-lg border border-gray-600 bg-blue-gray bg-opacity-20 p-2.5 ps-10 pe-10 text-gray-400 text-xs placeholder-gray-400 focus:border-blue-gray focus:ring-blue-gray"
					placeholder={placeholder}
					title={title}
				/>
				<div
					data-testid={`${baseTestId}-clear`}
					className="absolute inset-y-0 end-0 flex cursor-pointer items-center pe-3.5"
					onClick={() => onClear(id)}
				>
					<svg
						className="h-4 w-4 text-gray-400 dark:text-white"
						aria-hidden="true"
						xmlns="http://www.w3.org/2000/svg"
						width="24"
						height="24"
						fill="none"
						viewBox="0 0 24 24"
					>
						<path
							stroke="currentColor"
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth="2"
							d="M6 18 17.94 6M18 18 6.06 6"
						/>
					</svg>
				</div>
			</div>
		</div>
	);
};

export default SearchInput;
